import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend
} from "recharts";

export default function TeamTrendsChart({ ajss, selectedYear }) {
  const [chartData, setChartData] = useState([]);
  const [excludedCount, setExcludedCount] = useState(0);

  useEffect(() => {
    if (!selectedYear) return;

    const data = ajss.filter(a => Number(a.year) === Number(selectedYear));
    if (!data.length) return;

    const monthsOrder = ["Feb", "Apr", "Jun", "Aug", "Oct", "Dec"];
    const getIdx = (m) => monthsOrder.indexOf(m);

    const groups = {};
    data.forEach(r => {
      const key = `${r.playerId}_${r.ageGroup}`;
      if (!groups[key]) {
        groups[key] = {
          playerId: r.playerId,
          playerName: r.playerName,
          ageGroup: r.ageGroup,
          results: []
        };
      }

      if (typeof r.rank === "number") {
        groups[key].results.push({
          year: Number(r.year),
          monthIdx: getIdx(r.month),
          rank: r.rank
        });
      }
    });

    const latestGroups = {};
    Object.values(groups).forEach(g => {
      if (!g.results.length) return;

      g.results.sort((a, b) =>
        a.year === b.year ? a.monthIdx - b.monthIdx : a.year - b.year
      );
      latestGroups[g.playerId] = g;
    });

    const summary = { Improved: 0, Maintained: 0, Dropped: 0 };
    let excluded = 0;

    Object.values(latestGroups).forEach(g => {
      if (g.results.length < 2) {
        excluded++;
        return;
      }

      const first = g.results[0].rank;
      const last = g.results[g.results.length - 1].rank;

      if (last < first) summary.Improved++;
      else if (last > first) summary.Dropped++;
      else summary.Maintained++;
    });

    setChartData([{ category: "AJSS", ...summary }]);
    setExcludedCount(excluded);
  }, [ajss, selectedYear]);

  return (
    <div className="p-4 bg-white shadow rounded-xl mb-4">
      <h1 className="mb-4">Ranking Improvement (AJSS)</h1>

      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={chartData}>
          <XAxis dataKey="category" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Improved" fill="#22c55e" />
          <Bar dataKey="Maintained" fill="#6366f1" />
          <Bar dataKey="Dropped" fill="#ef4444" />
        </BarChart>
      </ResponsiveContainer>

      {excludedCount > 0 && (
        <p className="mt-2 text-sm text-gray-500 italic">
          Note: {excludedCount} player(s) excluded.
        </p>
      )}
    </div>
  );
}
